import React from "react";
import { Typography } from "antd";
import cls from "classnames";

import styles from "../CreditRequestInstructions.module.less";

const { Text } = Typography;

export const BulletsList = ({ items, className }) => {
  return (
    <ul className={cls(styles.bulletsList, className)}>
      {items.map((item, index) => (
        <li key={index}>
          <Text>{item}</Text>
        </li>
      ))}
    </ul>
  );
};
